<template>
  <editor-wrap :editor-id="this.editorConfig.id" :config="{ id: 'stock' }">
    <template v-slot="{disabledNext, onNext, onPrevious, disabledPrev, current, total, onClose}">
      <editor
        :disabled="disabled"
        :config="editorConfig"
        @on-quick-rfq="onQuickRFQ"
        @on-close="onClose"
      >
        <template v-slot="{ title }">
          <div class="row">
            <div class="col">
              {{title}}
            </div>
            <div class="col">
              {{current}} / {{total}}
            </div>
            <div class="col-auto">
              <el-button class="btn btn-size-s btn-white" :disabled="disabledPrev" @click="onPrevious">
                {{L10n('previous')}}
              </el-button>
              <el-button class="btn btn-size-s btn-white" :disabled="disabledNext" @click="onNext">
                {{L10n('next')}}
              </el-button>
            </div>
          </div>
        </template>
      </editor>
    </template>
  </editor-wrap>
</template>

<script>

export default {
  name: 'StockEditorWrapper',
  components: {
    'editor': () => import(/* webpackChunkName: 'Parts' */ './editor'),
    'editor-wrap': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Stock')
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    onQuickRFQ: {
      type: Function,
      required: true
    }
  },
  computed: {
    editorConfig () {
      return {
        id: 'stock-item',
        api: 'Stocks/Get/'
      }
    }
  }
}
</script>
<style scoped>
.pager{
  font-weight: bold;
  font-size: 2rem;
  margin-left: auto;
}
</style>
